import React from 'react'

export const LeadInformation = ({props,budget}:any) => {
  const {age, city, name , email ,phone , gender, country, state , student,relationship_status,educational_qualification,occupation,occupation_type} = props;
  return (
    <div className="col-sm-7">
    <h4>Lead Information</h4>
    <table className="table table-striped border-0 mt-4">
      <tbody>
        <tr>
          <th scope="row">Name:</th>
          <td colSpan={3}>{name}</td>
        </tr>
        <tr>
          <th scope="row">Age:</th>
          <td>{age}</td>
          <th scope="row">Gender:</th>
          <td>{gender}</td>
        </tr>
        <tr>
          <th scope="row">Phone:</th>
          <td colSpan={3}>{phone}</td>
        </tr>
        <tr>
          <th scope="row">Email:</th>
          <td colSpan={3}>{email}</td>
        </tr>
        <tr>
          <th scope="row">Budget:</th>
          <td colSpan={3}>{budget}</td>
        </tr>
        <tr>
          <th scope="row">City:</th>
          <td>{city}</td>
          <th scope="row">State:</th>
          <td>{state}</td>
        </tr>
        <tr>
          <th scope="row">Country:</th>
          <td>{country}</td>
          <th scope="row">Student:</th>
          <td>{student}</td>
        </tr>
        <tr>
          <th scope="row">Relationship Status:</th>
          <td>{relationship_status}</td>
        </tr>
        <tr>
          <th scope="row">Educational Qualification:</th>
          <td colSpan={3}>{educational_qualification}</td>
        </tr>
        <tr>
          <th scope="row">Occupation</th>
          <td>{occupation}</td>
          <th scope="row">Occupation Type:</th>
          <td>{occupation_type}</td>
        </tr>
      </tbody>
    </table>
  </div>
  )
}
